import React, { MouseEvent } from 'react';
import { CheckBoxColors } from '../../../enums/colors/checkBoxColors.type';
import { useGetLangDirectionApp } from '../../../stores/app.store';

type Props = {
    value: number | string,
    id: string,
    name: string,
    onClick?: (e: MouseEvent<HTMLInputElement>) => void,
    onBlur?: () => void,
    label: string,
    isChecked: boolean,
    color?: CheckBoxColors,
    disabled?: boolean,
}

const RadioOutlineBtn = ({ 
    value, 
    id, 
    name,
    onClick = () => {},
    onBlur = () => {},
    label = "",
    isChecked = false,
    color = CheckBoxColors.SUCCESS,
    disabled = false
}: Props) => {

    const langDirApp = useGetLangDirectionApp();
    const isLtr = langDirApp === 'ltr';

    const bootstrapClassOutline = color ? `btn-outline-${color}` : "btn-outline-success";

    return (
        <>
            <input
                checked={isChecked}
                value={value}
                onBlur={onBlur}
                id={id}
                name={name}
                className="btn-check"
                type='radio'
                autoComplete="off"
                onClick={(e) => onClick(e)}
                onChange={() => { }} // Add an empty onChange to avoid React warnings
                disabled={disabled}
            />
            <label
                className={`btn ${bootstrapClassOutline}`}
                htmlFor={id}
            >
                {label}
            </label>
        </>
    )
}

export default RadioOutlineBtn;